import http from "../http-common";

class AccessDataService {
  getAll() {
    return http.get("/access");
  }

  get(id) {
    return http.get(`/access/${id}`);
  }

  create(data) {
    return http.post("/access", data);
  }

  update(id, data) {
    return http.put(`/access/${id}`, data);
  }

  delete(id) {
    return http.delete(`/access/${id}`);
  }

  deleteAll() {
    return http.delete(`/access`);
  }

  findByUsername(name) {
    return http.get(`/access?name=${name}`);
  }
}

export default new AccessDataService();
